import { GameColors } from './Constants';

// Each seat's colour as the game shows it (player one blue, two red, three green, four yellow): readable on white, and
// a soft background
const Seats = ['PlayerOne', 'PlayerTwo', 'PlayerThree', 'PlayerFour'];
export const SeatColor = (seat) => GameColors.TextFocused[Seats[seat]] ?? '#555';
export const SeatBackground = (seat) => GameColors.Background[Seats[seat]] ?? '#eee';
